<template>
  <v-list v-if="paymentOptions && showSection" id="paymentId" subheader>
    <!--    <v-subheader-->
    <!--      class="title-header-card-item-component mb-4"-->
    <!--      v-text="$t('checkout.payment')"-->
    <!--    />-->

    <v-item-group>
      <v-item class="my-1">
        <CardPaymentComponents
          :is-ready="!!paymentSelected"
          :actions="showError"
        >
          <template v-slot:expantion>
            <v-item-group
              v-show="paymentProvider !== 'flatpay' ? !showNewCardForm : true"
              v-model="paymentSelected"
              mandatory
              style="width: 100%"
            >
              <v-expansion-panels focusable flat>
                <v-item
                  v-for="(item, index) in paymentOptions"
                  :key="index"
                  v-slot="{ active, toggle }"
                  class="mb-1"
                  :value="item"
                >
                  <v-expansion-panel
                    :v-ripple="!$store.getters.isLoading"
                    readonly
                    :class="{ active: active }"
                    @click="
                      item.slug !== 'online-payment' ? (show = !show) : ''
                    "
                    @click.capture="toggle"
                  >
                    <div :class="{ 'payment-h-p': active }">
                      <v-expansion-panel-header hide-actions>
                        <v-container fluid pa-0 ma-0>
                          <v-row
                            no-gutters
                            justify="space-between"
                            align="center"
                          >
                            <v-col>
                              <v-row
                                no-gutters
                                justify="start"
                                align-content="center"
                              >
                                <v-icon
                                  :color="active ? 'primary' : ''"
                                  v-text="
                                    active
                                      ? 'mdi-radiobox-marked'
                                      : 'mdi-radiobox-blank'
                                  "
                                />
                                <v-col class="ml-4">
                                  <v-container fluid fill-height pa-0 ma-0>
                                    <v-row no-gutters>
                                      <v-col cols="12">
                                        <span
                                          class="list-text-title"
                                          v-text="$t('checkout.' + item.slug)"
                                        />
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col
                              v-if="item.slug === 'online-payment'"
                              cols="auto"
                            >
                              <v-row>
                                <v-img
                                  src="@/assets/img/creditcards/visa.png"
                                  max-width="40"
                                  contain
                                  class="ml-2"
                                />
                                <v-img
                                  src="@/assets/img/creditcards/mastercard.png"
                                  max-width="40"
                                  contain
                                  class="ml-2"
                                />
                                <v-img
                                  src="@/assets/img/creditcards/amex.png"
                                  max-width="40"
                                  contain
                                  class="ml-2"
                                />
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-expansion-panel-header>
                    </div>
                    <v-container
                      v-if="item.slug === 'online-payment'"
                      v-show="paymentSelected.slug == 'online-payment'"
                      fluid
                      pa-0
                      ma-0
                      py-5
                      px-md-5
                      class="test_green"
                    >
                      <v-btn
                        v-if="
                          $store.getters.checkAuth &&
                          showNewCardForm &&
                          paymentProvider === 'flatpay'
                        "
                        color="primary"
                        icon
                        @click="selectDefaultCard()"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-row
                        v-if="$store.getters.checkAuth"
                        dense
                        class="test_blue"
                        justify="center"
                        align="center"
                      >
                        <CardProviderInfo
                          v-if="
                            $store.getters.checkAuth &&
                            showNewCardForm &&
                            paymentProvider === 'flatpay'
                          "
                        />
                        <v-list-item-group
                          v-if="
                            paymentProvider !== 'flatpay'
                              ? true
                              : !showNewCardForm
                          "
                          v-model="selectedCreditCard"
                          color="primary"
                          style="width: 100%"
                        >
                          <v-list-item
                            v-for="payment in itemsPayment"
                            :key="payment.id"
                            class="list-group-item my-2 px-5"
                            :value="payment.id"
                          >
                            <v-list-item-icon
                              class="mx-0 mr-4 d-flex align-center"
                            >
                              <v-img
                                :src="getImageSrc(payment.brand)"
                                style="image-rendering: optimizeSpeed"
                                contain
                                class="img-banner-container"
                                width="45px"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="primary"
                                    />
                                  </v-row>
                                </template>
                              </v-img>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title
                                v-text="getCardNumber(payment)"
                              />
                            </v-list-item-content>

                            <v-list-item-action v-ripple>
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon
                                      v-text="
                                        'mdi-dots-vertical-circle-outline'
                                      "
                                    />
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item-group color="primary">
                                    <v-list-item @click="deleteCard(payment)">
                                      <v-list-item-title
                                        v-text="$t('general.delete')"
                                      />
                                    </v-list-item>
                                  </v-list-item-group>
                                </v-list>
                              </v-menu>
                            </v-list-item-action>
                          </v-list-item>
                          <v-list-item
                            :key="0"
                            class="list-group-item my-2 px-5"
                            :value="0"
                            @click="addNewCard()"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="$t('customerProfile.addNewCard')"
                              />
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-row>

                      <v-row
                        v-else
                        dense
                        class="test_blue"
                        justify="center"
                        align="center"
                      >
                        <v-col
                          cols="12"
                          class="test_yellow"
                          style="
                            display: flex;
                            justify-content: center;
                            width: 100%;
                          "
                        >
                          <div style="max-width: 400px; width: 100%">
                            <StripeCardInput
                              v-if="paymentProvider === 'stripe'"
                              :stripe="stripe"
                              @handleError="handleError"
                              @handleCompleteCard="handlerConfirmCardInput"
                            />
                            <CardProviderInfo
                              v-if="paymentProvider === 'flatpay'"
                            />
                          </div>
                        </v-col>
                        <!--                        <v-col cols="10">-->
                        <!--                          <ButtonSuccess-->
                        <!--                            v-if="paymentProvider === 'stripe'"-->
                        <!--                            :valid="valid"-->
                        <!--                            @click="show = !show"-->
                        <!--                          />-->
                        <!--                        </v-col>-->
                      </v-row>
                    </v-container>
                  </v-expansion-panel>
                </v-item>
              </v-expansion-panels>
            </v-item-group>

            <v-col
              v-if="showNewCardForm && paymentProvider !== 'flatpay'"
              cols="12"
              class="test_yellow"
            >
              <v-container>
                <v-row justify="center">
                  <div style="max-width: 400px; width: 100%">
                    <StripeCardInput
                      v-if="paymentProvider === 'stripe'"
                      :stripe="stripe"
                      @handleError="handleError"
                      @handleCompleteCard="handlerConfirmCardInput"
                    />
                  </div>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" sm="8" md="8">
                    <v-row justify="space-around">
                      <v-col v-if="paymentProvider !== 'flatpay'" cols="5">
                        <ButtonSuccess
                          title="customerProfile.addNewCard"
                          :valid="validAddNewCard"
                          @click="handlerSaveCard()"
                        />
                      </v-col>
                      <v-col v-if="paymentProvider !== 'flatpay'" cols="5">
                        <ButtonCancel
                          :disabled-loading="true"
                          @click="selectDefaultCard()"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </template>
        </CardPaymentComponents>
      </v-item>
    </v-item-group>
  </v-list>
</template>

<script>
import { Months, Years } from "./../data/creditCard";
import i18n from "@/plugins/i18n";
import StripeCardInput from "@/views/front/checkout/components/StripeCardInput.vue";
import CardProviderInfo from "@/views/front/checkout/components/CardProviderInfo.vue";
import CardPaymentComponents from "@/components/cards/CardPaymenComponent.vue";
import defaultCardImage from "@/assets/img/creditcards/default.png";
import visaImage from "@/assets/img/creditcards/visa.png";
import mastercardImage from "@/assets/img/creditcards/mastercard.png";
import amexImage from "@/assets/img/creditcards/amex.png";
import discoverImage from "@/assets/img/creditcards/discover.png";
import jcbImage from "@/assets/img/creditcards/Jcb.png";
import dinersclubImage from "@/assets/img/creditcards/diners.png";
import unionpayImage from "@/assets/img/creditcards/unionpay.png";

export default {
  name: "PaymentX",
  components: {
    CardPaymentComponents,
    StripeCardInput,
    // ReepayComponent,
    CardProviderInfo,
  },
  directives: {
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },
  props: {
    stripe: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    paymentSelected: null,
    paymentProvider: "flatpay",
    isCardFilled: false,
    isCardFilledAddNewCard: false,
    show: true,
    showSection: true,
    valid: false,
    validAddNewCard: false,
    months: Months,
    years: Years,
    minCardYear: new Date().getFullYear(),
    mainCardNumber: "",
    cardNumberMaxLength: 19,
    valueFields: {
      cardName: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cardCvv: "",
    },
    inputFields: {
      cardNumber: "v-card-number",
      cardName: "v-card-name",
      cardMonth: "v-card-month",
      cardYear: "v-card-year",
      cardCvv: "v-card-cvv",
    },
    options: {
      duration: 1500,
      offset: 0,
      easing: "linear",
    },
    selectedCreditCard: 0,
    itemsPayment: null,
    paymentSelectedTitle: null,
    showNewCardForm: false,
    infoCard: null,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    cardImages: {
      visa: visaImage,
      mastercard: mastercardImage,
      amex: amexImage,
      discover: discoverImage,
      jcb: jcbImage,
      dinersclub: dinersclubImage,
      unionpay: unionpayImage,
    },
  }),
  computed: {
    showError: function () {
      return !this.$store.getters.checkoutValidation.paymentInfo.status;
    },
    paymentOptions: function () {
      return this.$store.getters.paymentOptionsList;
    },
    minCardMonth() {
      if (this.valueFields.cardYear === this.minCardYear)
        return new Date().getMonth() + 1;
      return 1;
    },
  },
  watch: {
    "$store.getters.deliveryMethod": function () {
      if (this.$store.getters.deliveryMethod) {
        this.$store.dispatch("checkout/loadPaymentOptions");

        if (!this.$store.getters.checkAuth) {
          setTimeout(() => {
            this.validate();
          }, 500);
        }
      }
    },
    cardYear() {
      if (this.valueFields.cardMonth < this.minCardMonth) {
        this.valueFields.cardMonth = "";
      }
    },
    valid() {
      this.validate();
    },
    show() {
      if (this.show === 0) {
        setTimeout(() => {
          document
            .getElementById("paymentId")
            .scrollIntoView({ behavior: "smooth" });
        }, 500);
      }
    },
    paymentSelected() {
      if (this.paymentSelected) {
        this.$store.dispatch(
          "checkout/setPaymentType",
          this.paymentSelected.slug
        );
        if (this.paymentSelected.slug === "online-payment") {
          if (this.selectedCreditCard > 0) {
            let found = this.itemsPayment.find(
              (item) => item.id === this.selectedCreditCard
            );
            this.paymentSelectedTitle = this.getCardNumber(found);
          } else {
            this.paymentSelectedTitle = this.$t(
              "checkout." + this.paymentSelected.slug
            );
          }
        } else {
          this.paymentSelectedTitle = this.$t(
            "checkout." + this.paymentSelected.slug
          );
          this.valid = true;
        }
      } else {
        this.$store.dispatch("checkout/setPaymentType", null);
      }
      this.validate();
    },
    paymentOptions() {
      if (this.paymentOptions) {
        this.paymentSelected = this.paymentOptions[0];
      }
    },
    "$store.getters.checkAuth": function () {
      if (this.$store.getters.checkAuth) {
        this.loadPaymentsMethods(true);
      } else {
        this.itemsPayment = null;
        this.selectedCreditCard = 0;
        this.showNewCardForm = false;
      }
    },
    selectedCreditCard: function () {
      if (this.selectedCreditCard > 0) {
        if (this.paymentSelected) {
          this.validate();
        }
        this.$emit("input", this.selectedCreditCard);
        this.show = false;
        let found = this.itemsPayment.find(
          (item) => item.id == this.selectedCreditCard
        );
        this.paymentSelectedTitle = this.getCardNumber(found);
      } else {
        if (this.$store.getters.checkAuth) {
          this.showNewCardForm = true;
        }
        this.validate();
        this.paymentSelectedTitle = this.$t(
          "checkout." + this.paymentSelected.slug
        );
      }
    },
    "$store.getters.cartDetails.cartTotal": function () {
      if (this.$store.getters.cartDetails.cartTotal === 0) {
        this.showSection = false;
        this.$store.dispatch("checkout/setPaymentType", "cash");
        this.validate();
      } else {
        this.showSection = true;
        if (this.paymentSelected) {
          this.validate();
        }
      }
    },
  },
  created() {
    this.paymentProvider = this.$store.getters.appInfo.paymentProvider;
  },
  mounted() {
    if (this.$store.getters.deliveryMethod) {
      this.$store.dispatch("checkout/loadPaymentOptions");
    }
    if (this.$store.getters.checkAuth) {
      this.loadPaymentsMethods();
    }
  },
  methods: {
    getImageSrc(brand) {
      if (!brand) return defaultCardImage;

      const brandLower = brand.toLowerCase();
      return this.cardImages[brandLower] || defaultCardImage;
    },
    getCardNumber(item) {
      return this.$store.getters.appInfo.paymentProvider === "flatpay"
        ? item.lastFourDigit
        : `**** **** **** ${item.lastFourDigit}`;
    },
    addNewCard: function () {
      this.showNewCardForm = true;
      if (
        this.$store.getters.checkAuth &&
        this.$store.getters.appInfo.paymentProvider === "flatpay"
      ) {
        this.$store.dispatch("checkout/setAddFlatPayMethod", true);
      }
    },
    logout: async function () {
      this.$store.dispatch("loading/start");
      await this.$store.dispatch("auth/logout");
      this.$router.push("/");
      this.$store.dispatch("loading/done");
    },
    handlerSaveCard: async function () {
      this.$store.dispatch("loading/start");
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.$store.getters.cardInputElement.cardNumberElement,
      });

      if (error) {
        Swal.fire({
          icon: "error",
          title: this.$t("errors.error_alert_title"),
          text: error.message,
          confirmButtonText: "Ok",
          showCloseButton: true,
        });
      } else {
        try {
          let form = new Form({
            payment_method: paymentMethod.id,
          });
          const { data } = await form.post(
            "/users/profiles/payment/pm_account"
          );
          this.loadPaymentsMethods().then();
          Toast.fire({
            icon: "success",
            title: data.message,
          });
          this.$store.dispatch("checkout/setCardInputElement", null);
          setTimeout(() => {
            this.selectedCreditCard = data.data.id;
          }, 500);

          this.showNewCardForm = false;
        } catch (e) {
          if (e.response && e.response.data && e.response.data.message) {
            const msg = e.response.data.message.toUpperCase();
            if (msg === "NOT_AUTHENTICATED") {
              this.logout().then();
            } else if (msg === "SAVE_PM_METHOD_FAILED") {
              Swal.fire({
                icon: "error",
                title: this.$t("errors.error_alert_title"),
                text: this.$t("errors.ERROR_SAVE_CARD", {
                  code: "SAVE_PM_METHOD_FAILED",
                }),
                confirmButtonText: "Ok",
                showCloseButton: true,
              });
            } else if (msg === "ATTACH_PM_METHOD_FAILED") {
              Swal.fire({
                icon: "error",
                title: this.$t("errors.error_alert_title"),
                text: this.$t("errors.ERROR_SAVE_CARD", {
                  code: "ATTACH_PM_METHOD_FAILED",
                }),
                confirmButtonText: "Ok",
                showCloseButton: true,
              });
            } else if (msg === "SETUP_PM_METHOD_FAILED") {
              Swal.fire({
                icon: "error",
                title: this.$t("errors.error_alert_title"),
                text: this.$t("errors.ERROR_SAVE_CARD", {
                  code: "SETUP_PM_METHOD_FAILED",
                }),
                confirmButtonText: "Ok",
                showCloseButton: true,
              });
            } else if (msg === "CREATE_ACCOUNT_FAILED") {
              Swal.fire({
                icon: "error",
                title: this.$t("errors.error_alert_title"),
                text: this.$t("errors.ERROR_SAVE_CARD", {
                  code: "CREATE_ACCOUNT_FAILED",
                }),
                confirmButtonText: "Ok",
                showCloseButton: true,
              });
            } else if (msg === "NOT_VALID_PM_METHOD") {
              Swal.fire({
                icon: "error",
                title: this.$t("errors.error_alert_title"),
                text: this.$t("errors.ERROR_SAVE_CARD", {
                  code: "NOT_VALID_PM_METHOD",
                }),
                confirmButtonText: "Ok",
                showCloseButton: true,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: this.$t("errors.error_alert_title"),
                text: this.$t("errors.COMMON_ERROR"),
                confirmButtonText: "Ok",
                showCloseButton: true,
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: this.$t("errors.error_alert_title"),
              text: this.$t("errors.COMMON_ERROR"),
              confirmButtonText: "Ok",
              showCloseButton: true,
            });
          }
        }
      }
      this.$store.dispatch("loading/done");
    },
    handlerConfirmCardInput: function () {
      this.valid = true;
      this.isCardFilled = true;
      this.validAddNewCard = true;
      this.validate();
    },
    handlerAddNewCardConfirmCardInput: function () {
      this.validAddNewCard = true;
      this.isCardFilledAddNewCard = true;
    },
    handleError: function (values) {
      this.valid = values.value;
      this.isCardFilled = values.value;
      this.validAddNewCard = values.value;
      this.validate();
    },
    handleErrorAddNewCard: function (values) {
      this.validAddNewCard = values.value;
      this.isCardFilledAddNewCard = values.value;
    },
    loadPaymentsMethods: async function () {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await axios.get("/users/profiles/payment/method");
      self.itemsPayment = data.data;
      if (data.data.length > 0) {
        if (self.selectedCreditCard === 0) {
          self.selectDefaultCard();
        }
      } else {
        this.addNewCard();
        self.selectedCreditCard = 0;
        if (this.$store.getters.appInfo.paymentProvider !== "flatpay") {
          self.$store.dispatch("checkout/setValidationPaymentInfo", {
            status: false,
            message: i18n.t("checkout.we_need_fill_payment"),
          });
        }
      }
      self.$store.dispatch("loading/done");
    },
    selectDefaultCard: async function () {
      this.isCardFilledAddNewCard = false;
      this.validAddNewCard = false;
      setTimeout(() => {
        this.showNewCardForm = false;
      }, 100);
      const self = this;
      if (self.itemsPayment.length > 0) {
        let found = self.itemsPayment.find((item) => item.isDefault === 1);
        if (found) {
          self.selectedCreditCard = found.id;
        } else {
          //TODO: if there is not default card
          self.selectedCreditCard = self.itemsPayment[0].id;
        }
      } else {
        self.selectedCreditCard = 0;
        self.$store.dispatch("checkout/setAddFlatPayMethod", false);
        self.showNewCardForm = false;
      }
      self.showNewCardForm = false;
    },
    changeNumber(e) {
      const value = this.valueFields.cardNumber.replace(/\D/g, "");
      // american express, 15 digits
      if (/^3[47]\d{0,13}$/.test(value)) {
        this.valueFields.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 17;
      } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
        // diner's club, 14 digits
        this.valueFields.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 16;
      } else if (/^62[0-9]\d*/.test(value)) {
        this.valueFields.cardNumber = value
          .replace(/(\d{6})/, "$1 ")
          .replace(/(\d{6}) (\d{7})/, "$1 $2 ")
          .replace(/(\d{6}) (\d{7}) (\d{6})/, "$1 $2 $3 ")
          .replace(/(\d{5}) (\d{5}) (\d{5}) (\d{4})/, "$1 $2 $3 $4");
        this.cardNumberMaxLength = 21;
      } else if (/^\d{0,16}$/.test(value)) {
        // regular cc number, 16 digits
        this.valueFields.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
          .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
        this.cardNumberMaxLength = 19;
      }
      // eslint-disable-next-line
      if (e.inputType == "deleteContentBackward") {
        const lastChar = this.valueFields.cardNumber.substring(
          this.valueFields.cardNumber.length,
          this.valueFields.cardNumber.length - 1
        );
        // eslint-disable-next-line
        if ((lastChar == " ") | (e == null)) {
          this.valueFields.cardNumber = this.valueFields.cardNumber.substring(
            0,
            this.valueFields.cardNumber.length - 1
          );
        }
      }
      this.$emit("input-card-number", this.valueFields.cardNumber);
    },
    changeMonth() {
      this.$emit("input-card-month", this.valueFields.cardMonth);
    },
    changeYear() {
      this.$emit("input-card-year", this.valueFields.cardYear);
    },
    changeCvv() {
      /* this.valueFields.cardCvv = e.target.value; */
      this.$emit("input-card-cvv", this.valueFields.cardCvv);
    },
    generateMonthValue(n) {
      return n < 10 ? `0${n}` : n;
    },
    saveCard: async function () {
      const self = this;
      self.$store.dispatch("loading/start");

      let form = new Form({
        email: self.$store.getters.user.email,
        name: self.infoCard.cardName,
        cardNumber: self.infoCard.cardNumber,
        expMonth: self.infoCard.cardMonth,
        expYear: self.infoCard.cardYear,
        cvc: self.infoCard.cardCvv,
      });

      const { data } = await form.post("/users/profiles/payment/method");
      self.loadPaymentsMethods();
      Toast.fire({
        icon: "success",
        title: data.message,
      });
      self.showForm = false;
    },
    deleteCard: async function (datas) {
      const self = this;
      const { value: result } = await Swal.fire({
        title: self.$t("general.delete"),
        html:
          self.$t("customerProfile.deletePaymentMethod") +
          " <b>**** **** **** " +
          +datas.lastFourDigit +
          "</b>?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      if (result) {
        self.$store.dispatch("loading/start");
        const { data } = await axios.delete(
          "/users/profiles/payment/method/" + datas.id
        );
        Toast.fire({
          icon: "success",
          title: data.message,
        });
        self.loadPaymentsMethods();
      }
    },
    validate: async function () {
      await this.$nextTick();

      if (this.$store.getters.paymentType === "online-payment") {
        if (this.$store.getters.checkAuth) {
          if (
            this.$store.getters.appInfo.paymentProvider === "flatpay" &&
            this.$store.getters.isNewFlatPayMethod
          ) {
            this.$checkoutValidator.paymentInfo(true);
          } else {
            this.$checkoutValidator.paymentInfo(this.selectedCreditCard > 0);
            this.$emit("input", this.selectedCreditCard);
          }
        } else {
          if (this.$refs.form) {
            this.$checkoutValidator.paymentInfo(this.$refs.form[0].validate());
            this.$emit("input", this.valueFields);
          } else {
            if (this.isCardFilled) {
              this.$checkoutValidator.paymentInfo(true);
            } else {
              this.$emit("input", this.valueFields);
              this.$checkoutValidator.paymentInfo();
            }
          }
        }
      } else {
        this.$store.getters.paymentType !== null
          ? this.$checkoutValidator.paymentInfo()
          : null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.list-text-title {
  font-size: 1.2rem;
  color: #000 !important;
}
</style>
<style lang="scss">
.v-application .mb-1 {
  margin-bottom: 0 !important;
}
.payment-h-p {
  border: 1px solid var(--v-primary-base) !important;
  background-color: #f4f4f4 !important;
}
.card-item__cover {
  background-image: linear-gradient(
    147deg,
    var(--v-primary-base) 0,
    #000 74%
  ) !important;
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .expantion .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }

  .card-item {
    width: 100% !important;
  }
}
</style>
